export const IMAGE_STORAGE_STATE_PATH = 'imageStorage';

export { default } from './imageStorage';
